import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import PublicRoutes from './_config/publicRoutes';
import { URLS } from './_config';
import Login from './pages/Auth/login';
import PrivateRoutes from './_config/privateRoutes';
import Home from './pages/home';
import Page404 from './pages/404';

import Profile from './pages/profile';
import Registration from './pages/Auth/registration';
import ForgotPassword from './pages/Auth/forgotPassword';
import ResetPassword from './pages/Auth/resetPassword';
import Facilities from './pages/Facilities';
import Assets from './pages/Assets';
import AssetsDetails from './pages/Assets/assetsDetails';
import SpearParts from './pages/Inventory/SpearParts';
import ReceiveStock from './pages/Inventory/ReceiveStock';
import StockAdjustment from './pages/Inventory/StockAdjustment';
import StockPicking from './pages/Inventory/StockPicking';
import CycleCount from './pages/Inventory/CycleCount';
import PurchaseRequest from './pages/Purchase/Request';
import PurchaseOrderPage from './pages/Purchase/Order';
import Stock from './pages/Purchase/Stock';
import SpearPartsDetails from './pages/Inventory/SpearParts/spearPartsDetails';
import { useAppLoader } from './_common/pageLoader/appLoaderHook';
import { useEffect } from 'react';




function App() {
	const { showLoader, hideLoader } = useAppLoader();

	useEffect(() => {
		hideLoader();
	}, []);
	return (
		<Router>
			
			<div className="App">
				<Routes>
					<Route element={<PublicRoutes />}>
						<Route path={URLS.AUTH.LOGIN} element={<Login />}></Route>
						<Route path={URLS.AUTH.REGISTER} element={<Registration />}></Route>
						<Route path={URLS.AUTH.FORGOT_PASSWORD} element={<ForgotPassword />}></Route>
						<Route path={URLS.AUTH.RESET_PASSWORD} element={<ResetPassword />}></Route>
					</Route>

					


					<Route element={<PrivateRoutes />}>
						<Route path={URLS.PROFILE} element={<Profile />}></Route>
						
					<Route path={URLS.HOME} element={<Home />}></Route>
					<Route path={URLS.RM_OVERVIEW} element={<Home />}></Route>
					<Route path={URLS.FACILITIES} element={<Facilities />}></Route>
					<Route path={URLS.ASSETS} element={<Assets />}></Route>
					<Route path={URLS.ASSETS_DETAILS()} element={<AssetsDetails />}></Route>
					<Route path={URLS.WARRANTIES} element={<Home />}></Route>
					<Route path={URLS.LEASE_ASSETS} element={<Home />}></Route>
					<Route path={URLS.DEPRECIATION} element={<Home />}></Route>
					<Route path={URLS.MAINTENANCE_CALENDER} element={<Home />}></Route>
					<Route path={URLS.WORK_ORDERS} element={<Home />}></Route>
					<Route path={URLS.CHECKLISTS} element={<Home />}></Route>

					<Route path={URLS.INVENTORY.SPEAR_PARTS.LIST} element={<SpearParts />} />
					<Route path={URLS.INVENTORY.SPEAR_PARTS.DETAILS()} element={<SpearPartsDetails />} />

					<Route path={URLS.INVENTORY.RECEIVE_STOCK} element={<ReceiveStock />}></Route>
					<Route path={URLS.INVENTORY.STOCK_ADJUSTMENT} element={<StockAdjustment />}></Route>
					<Route path={URLS.INVENTORY.STOCK_PICKING} element={<StockPicking />}></Route>
					<Route path={URLS.INVENTORY.CYCLE_COUNT} element={<CycleCount />}></Route>
					<Route path={URLS.PURCHASING.REQUEST} element={<PurchaseRequest />}></Route>
					<Route path={URLS.PURCHASING.ORDER} element={<PurchaseOrderPage />}></Route>
					<Route path={URLS.PURCHASING.STOCK} element={<Stock />}></Route>
					<Route path={URLS.VENDORS} element={<Home />}></Route>
					<Route path={URLS.USERS} element={<Home />}></Route>
					<Route path={URLS.REPORTS} element={<Home />}></Route>
					<Route path={URLS.SETTINGS} element={<Home />}></Route>
					<Route path={URLS.ACCOUNT} element={<Home />}></Route>
					</Route>

					<Route path={`*`} element={<Page404 />}></Route>
				</Routes>
			</div>
		</Router>
	);
}

export default App;
